import { render } from "./HeaderGlobal.vue?vue&type=template&id=a94e2784"
import script from "./HeaderGlobal.vue?vue&type=script&lang=js"
export * from "./HeaderGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__